import Offcanvas2 from "@components/new_offcanvas/offcanvas_2"
import store from "../../store/store"
import colors from "../../helpers/colors"
import locale from "@packs/locale/locale"
import spinners from "@components/loader/spinners"

import('./style.scss')

export default function OffcanvasController(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    let offcanvas2

    this.openOffcanvas = () =>{
        
    }

    this.update = () =>{
        if(offcanvas2.getCurrentState()){
            generateList()
        }
        
    }

    const generateList = _ =>{
        let TYPE = store.mainConfigStore.getType()
        let stations = store.fluConfig.getStations()
        $(elements.table_events_content).html('')
        $(elements.table_two_container).html('')

        if(TYPE === 'flu'){
            stations.forEach(station=>{ 
                
                let status = station.marker ? station.marker.options.icon.options.status : undefined
                if(status != 'ok' && status != 'default' && status != undefined && status != ""){
                    station.status = status
                    let row = eventTableRow(station)
                    $(elements.table_events_content).append(_=>row)

                    setTimeout(_=>{
                        $(row).on('click', _ =>{
                            context.trigger('EVENT_TABLE_ROW_CLICK', {obj:station, type:'station'})
                        })
                    },100)
                }
            })
        } else {
            if(stations.length > 0){
                let ordered = stations.sort((x, y) => y.value - x.value)
                let max_value = ordered[0].value
                for(let i = 0; i < ordered.length; i++){
                    let row = eventTableRow(ordered[i],max_value)
                    $(elements.table_events_content).append(_=>row)

                    setTimeout(_=>{
                        $(row).on('click', _ =>{
                            context.trigger('EVENT_TABLE_ROW_CLICK', {obj:ordered[i], type:'station'})
                        })
                    },100)

                    if(i === 19){
                        break;
                    }
                }
                generateTableUgrhiContent()
            }
        }
        //plu vai ter dois containers metade da área. flu vai ter um container full
        offcanvas2.updateContent([{size: TYPE==='plu' ? 'half' : 'full', content:elements.table_events_container}, TYPE === 'plu' ? {size: 'half', content:elements.table_two_container} : {}])
    }

    const generateTableUgrhiContent = _ =>{
        let stations = store.fluConfig.getStations()
        let ugrhis = {}
        $(elements.table_two_container).html('<div class="events-table-title">Média por Ugrhi</div>')

        stations.forEach(station=>{
            ugrhis[station.ugrhi_cod] = ugrhis[station.ugrhi_cod] || []
            ugrhis[station.ugrhi_cod].push(station.value)
        })

        $.each(ugrhis, (cod, values)=>{
            let value = values.reduce((p,c)=>p+c,0) / values.length
            ugrhis[cod] = value
        })

        let ordereds = Object.entries(ugrhis).sort((x, y) => y[1] - x[1])

        ordereds.forEach(ordered=>{
            let row = ugrhiTableRow(ordered)
            
            $(elements.table_two_container).append(row)
            setTimeout(_=>{
                $(row).on('mouseover', _ =>{
                    context.trigger('EVENT_TABLE_ROW_MOUSEOVER', {obj:ordered[0],type:'ugrhi'})
                })
                $(row).on('mouseout', _ =>{
                    context.trigger('EVENT_TABLE_ROW_MOUSEOUT', {obj:ordered[0],type:'ugrhi'})
                })
                $(row).on('click', _ =>{
                    context.trigger('EVENT_TABLE_ROW_CLICK', {obj:ordered[0],type:'ugrhi'})
                })
            },100)
        })
        
    }

    const ugrhiTableRow = (data) =>{
        let TYPE = store.mainConfigStore.getType()
        let el = context.createElement('div', `events-table-row events-table-${TYPE}`)
        let rowOne = context.createElement('div', 'row-title')

        $(rowOne).html(`<div class='prefix'>${ugrhis.find(x=>x.cod === parseInt(data[0])).name}</div><div class='status text-white'>${data[1].toFixed(1)} mm</div>`)

        $(el).append(rowOne)
        

        return  el
    }

    const eventTableRow = (station, max) =>{
        let TYPE = store.mainConfigStore.getType()
        let el = context.createElement('div', `events-table-row events-table-${TYPE}`)
        let rowOne = context.createElement('div', 'row-title')
        let rowTwo = context.createElement('div', 'value-bar')

        $(rowOne).html(`<div class='prefix'>${station.station_name || station.station.name}</div><div class='status' style='color:${colors[station.status]};${TYPE==='flu' ? 'text-transform:capitalize' : ''}'>${TYPE === 'flu' ? locale.t(station.status) : station.value.toFixed(1) + " mm"}</div>`)

        if(TYPE == 'plu'){
            $(rowTwo).css({
                width: `${station.value * 100 / max}%`,
                backgroundColor: colors[station.status]
            })
        }

        $(el).append(rowOne, rowTwo)
        

        return  el
    }

    init()

    function init(){

        offcanvas2 = new Offcanvas2({container:'.map-container', options:{position:'right'}})

        offcanvas2.on('open', _ =>{
            generateList()
        })

        elements.table_events_container = context.createElement('div', 'offcanvas-table-content-wrapper')
        elements.table_two_container = context.createElement('div', 'offcanvas-table-content-wrapper')

        elements.table_events_title = context.createElement('div', 'events-table-title', 'Eventos no período')
        elements.table_events_content = context.createElement('div', 'events-table-content pretty-scrollbar scrollbar-white')
        
        $(elements.table_events_container).append(elements.table_events_title, elements.table_events_content)

    }
}

OffcanvasController.prototype = Object.create(BaseConstructor.prototype)